var Loader3D = (function () {
    function Loader3D() {
    }
    return Loader3D;
}());
export { Loader3D };
